import { i18nMark } from 'lingui-react';

const messages = {
  addNote: i18nMark('Add Note'),
  asset: i18nMark('Asset'),
  caseStatus: i18nMark('Case Status'),
  complaint: i18nMark('Complaint'),
  diagnostics: i18nMark('Diagnostics'),
  estimateInvoiceDecided: i18nMark('Estimate/Invoice'),
  estimateInvoicePending: i18nMark('Estimate/Invoice'),
  jumpTo: i18nMark('Jump To...'),
  location: i18nMark('Location'),
  notes: i18nMark('Notes'),
  options: i18nMark('Options'),
  printPage: i18nMark('Print Page'),
  requestService: i18nMark('Request Service'),
  serviceProvider: i18nMark('Service Provider'),
  serviceRequest: i18nMark('Service Request'),
  viewInFullScreenMode: i18nMark('View In Full-Screen Mode'),
  // In alpha version we don't have assignCase, addAttachment, and setFollowup.
  // addAttachment: i18nMark('Add Attachment'),
  // assignCase: i18nMark('Assign Case'),
  // setFollowUp: i18nMark('Set Follow Up'),
};

export default messages;



// WEBPACK FOOTER //
// ./containers/QuickActionBarContainer/messages.js